import { render, staticRenderFns } from "./VTravelForm.vue?vue&type=template&id=104dfd16&"
import script from "./VTravelForm.vue?vue&type=script&lang=js&"
export * from "./VTravelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports